import { useState, Fragment, useEffect } from 'react'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Input, Label, Form, FormGroup } from 'reactstrap'
import Utils from '../Utils'

const ModalCuota = ({ isOpen, pago, fetchPagos, closeModal }) => {

    const [form, setForm] = useState(pago)

    const onSubmit = event => {
        event.preventDefault()
    }

    const handleInputChange = ({ target }) => {
        setForm({
            ...form,
            [target.name]: target.value
        })
    }

    const guardarCambios = async () => {
        if(window.confirm("Realmente quieres modificar la cuota?") == false) {
            return;
        }
        //
        try {
            // call API
            await Utils.API.CambiarExpiracion(pago.idPago, getFecha())
            //refresh
            fetchPagos()
            closeModal()
            alert("Cuota modificada!")
        } catch(err) {
            console.error(err)
            Utils.AlertError(err, "No se pudo actualizar la cuota")
        }
    }

    const getFecha = () => {
        
        let fechaObj = new Date()

        if(form != null) {
            // check if is native input
            if(form.FechaExpiracion.indexOf("T") == -1) {
                return form.FechaExpiracion
            }
            // parse date
            fechaObj = new Date(form.FechaExpiracion)
        }

        return fechaObj.toISOString().split('T')[0]    
    }

    useEffect(() => {
        setForm(pago)
    }, [pago])

    if(pago == null || form == null) {
        return(
            <div />
        )
    }


    return(
        <Modal
            isOpen={isOpen}
            backdrop={"static"}
        >
            <ModalHeader>Modificar Pago: #{pago.idPago}</ModalHeader>
            <ModalBody>
                <Form>
                    <FormGroup>
                        <Label>Fecha:</Label>
                        <Input
                            onChange={handleInputChange}
                            type="date"
                            name="FechaExpiracion"
                            value={getFecha()}
                        />
                    </FormGroup>
                </Form>
            </ModalBody>
            <ModalFooter>
                <Button onClick={guardarCambios} color='primary'>
                    Modificar
                </Button>
                <Button onClick={closeModal} color='danger'>
                    Cancelar
                </Button>
            </ModalFooter>
        </Modal>
    )
}

export default ModalCuota